module.exports = __webpack_public_path__ + "static/media/edit-agenda.a6e335a8.svg";